//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            petcountStr: [],
            questionCountStr: []
        }
    },
    mounted() {
        this.getTotal()
    },
    methods: {
        getTotal() {
            this.$http
                .get(`${this.$store.state.origin}/api/query/v2/query/totalQuery`)
                .then(res => {
                    var result = res.body.result
                    var petcount = result.value.split(",")[0].split("")
                    var questionCount = result.value.split(",")[1].split("")
                    this.petcountStr = []
                    this.questionCountStr = []
                    this.petcountStr = result.value.split(",")[0].split("")
                    this.questionCountStr = result.value.split(",")[1].split("")
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/helpRecord.vue